export enum SpecialFileType {
  RobotsTxt = 'robots.txt',
  SitemapXml = 'sitemap.xml',
  LLMSTxt = 'llms.txt',
  MD = '.md',
}

export function isRootSpecialFileType(
  specialFileType: SpecialFileType | string | undefined,
): specialFileType is SpecialFileType.SitemapXml | SpecialFileType.LLMSTxt {
  return (
    specialFileType === SpecialFileType.SitemapXml || specialFileType === SpecialFileType.LLMSTxt
  );
}
